






































import { defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadFooter',
    props: {
        valid: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const { state, steps, close, submit } = useCreateLeadForm()

        return {
            state,
            steps,
            close,
            submit,
        }
    },
})
